import styled, { css } from 'styled-components';

const StyledContainer = styled.div<{ $side: 'left' | 'right' }>`
	display: flex;
	flex-direction: column;
	gap: 10px;
	position: absolute;
	${(props) =>
		props.$side === 'left'
			? css`
					left: 20px;
					align-items: flex-start;
			  `
			: css`
					right: 20px;
					align-items: flex-end;
			  `}

	transform: translateY(-50%);
	top: 50%;
	user-select: none;
`;

const StyledVerticalContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 10px;
	max-width: fit-content;
	max-height: fit-content;
	padding: 10px;
	border-radius: 6px;
	background-color: rgba(0, 0, 0, 0.9);

	& > span {
		font-family: 'GT Walsheim Pro';
		font-size: 14px;
		color: #ffffff;
	}
`;

const StyledHorizontalContainer = styled.div`
	display: flex;
	flex-direction: row;
	gap: 20px;
	position: relative;
`;

export { StyledContainer, StyledHorizontalContainer, StyledVerticalContainer };
